import storage from './storage';
import Icons from './icons';
import { Alert, isWeb } from 'core';
import { DangerZone } from 'expo';
import { lang } from 'lang';
import { COUNTRIES } from 'constants';

import * as db from './db';
import * as CDN from './cdn';
export * from './crud';
export * from './uploader';
export * from './url';
export * from './cache';
export * from './template';
export * from './image_processor';

export { storage, db, Icons, CDN };
export const sleep = (time = 1) => new Promise(resolve => setTimeout(resolve, time));

export const getDefaultDueDate = () => {
  const date = new Date();
  date.setHours('23', '59');
  return date.getTime();
};

export const search = (source, branch, keyword, limit = 10) => {
  if (!keyword) {
    return source;
  }
  if (!limit) {
    limit = 9999;
  }
  if (!Array.isArray(branch)) {
    branch = [branch];
  }
  let result = [];
  keyword = keyword
    .toLowerCase()
    .replace(/أ|إ/g, 'ا')
    .replace(/ة/g, 'ه');
  for (let i = 0; i < source.length; i++) {
    for (let j = 0; j < branch.length; j++) {
      if (
        source[i][branch[j]] &&
        source[i][branch[j]]
          .toLowerCase()
          .replace(/أ|إ/g, 'ا')
          .replace(/ة/g, 'ه')
          .includes(keyword)
      ) {
        result.push(source[i]);
        break;
      }
    }
  }
  return result;
};
export const getBlob = async uri => {
  let blob;
  try {
    const response = await fetch(uri);
    blob = await response.blob();
    const { size, name, type } = blob._data;
    blob.name = name;
    blob.size = size;
    blob.type = type;
  } catch (e) {
    Alert.alert(lang.ERR_FETCH_FILE_TITLE, lang.ERR_FETCH_FILE_TXT);
  }
  return blob;
};

export const getCountryCode = async () => {
  let json;
  try {
    const res = await fetch(`https://ipinfo.io/json`);
    json = await res.json();
  } catch (e) {
    json = {};
  }
  return json.country || 'SA';
};

export const getCountryTeleCode = async () => {
  const country_code = await getCountryCode();
  const tel_code = COUNTRIES[country_code].tel;
  return { country_code, tel_code };
};

export const whyCompUpdated = (prevProps, nextProps, content) => {
  const prev_keys = Object.keys(prevProps);
  const next_keys = Object.keys(nextProps);

  let keys = {};

  prev_keys.forEach(key => (keys[key] = true));
  next_keys.forEach(key => (keys[key] = true));

  keys = Object.keys(keys);

  keys.forEach(key => {
    if (prevProps[key] !== nextProps[key]) {
      content && console.log(prevProps[key], nextProps[key]);
    }
  });
};

export const parseArabicNumber = str =>
  str
    .replace(/[٠١٢٣٤٥٦٧٨٩]/g, function(d) {
      return d.charCodeAt(0) - 1632; // Convert Arabic numbers
    })
    .replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function(d) {
      return d.charCodeAt(0) - 1776; // Convert Persian numbers
    });



// WEBPACK FOOTER //
// ./src/utils/index.js